import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as commonActions from "../../../../../actions/common.actions";
import AdminCreateUsers from "../components/AdminCreateUsers";
import { createAdmin, showToast } from "../../../../../actions/admin.actions";
import Toast from "../../../../../components/common/toast/Toast";

const subHeader = () => {
  return {
    items: [
      {
        caption: "Project",
        url: `/admin/new/projects`
      },
      {
        caption: "Admin",
        url: `/admin/new/users`
      },
      {
        caption: "Referral Codes",
        url: `/admin/new/referral-codes`
      }
    ],
    activeItem: 1
  };
};

class AdminCreateUsersContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onToastClose = this.onToastClose.bind(this);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(subHeader());
    if (this.props.show) {
      this.toast.showToast(this.onToastClose);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      if (nextProps.show) {
        this.toast.showToast(this.onToastClose);
      }
    }
  }

  onToastClose() {
    this.props.showToast(false);
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  handleSubmit(data) {
    this.props.createAdmin(data);
  }

  render() {
    return (
      <div>
        <Toast
          onRef={ref => (this.toast = ref)}
          title="Success!"
          content="The user has been created."
        />
        <AdminCreateUsers onSubmit={this.handleSubmit} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    show: state.admin.showToast
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createAdmin: data => dispatch(createAdmin(data)),
    showToast: show => dispatch(showToast(show)),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCreateUsersContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/new/users/containers/AdminCreateUsersContainer.js